<template>
  <div class="top_nav_item" @click="itemclick">
    <slot name="topnavimg"></slot>
    <slot name="topimgtext"></slot>

    <!--  修改昵称图片样式插槽大图标 配合下面的input使用-->
    <!-- input输入框插槽 -->
    <!-- <div
      class="config_nickName_input_wraper"
      v-if="this.$slots['config_nickName_input']"
    > -->
    <div
      class="config_nickName_input"
      v-if="this.$slots['config_nickName_input']"
    >
      <slot name="config_nickName_input"></slot>
      <slot name="config_nickName_xiugai"></slot>
    </div>

    <!-- </div> -->
    <!-- 界面管理  完成  退出 样式 -->
    <div class="config_jie_mian" v-if="this.$slots['config_jie_mian']">
      <slot name="config_jie_mian"></slot>
    </div>
    <!-- 行的开关按钮图片的插槽 -->
    <!-- <div
      class="config_hang_switchBtn_close"
      v-if="this.$slots['config_hang_switchBtn_close']"
    >
      <slot name="config_hang_switchBtn_close"></slot>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: 'nullpath'
    }
  },
  methods: {
    itemclick() {
      ////顶部导航栏所有元素的点击事件
      console.log('itemclick11')
      console.log(this.path)
      if (this.path === 'nullpath') return
      this.$router.replace(this.path)
    }
    // xiugaiBtnHandle() {}
  }
}
</script>

<style>
.top_nav_item {
  flex: 1;
  text-align: center;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;

  /* padding-left: 20px;
  padding-right: 20px; */

  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}

.config_nickName_input input {
  background: none;
  border: none;
  font-size: 18px;
  width: 70%;

  text-align: center;
  color: #ffffff;
}
/* .config_nickName_xiugai {
  position: relative;
} */
.config_nickName_input img {
  width: 21px;
  height: 21px;

  position: relative;
  top: 4px;
  left: 5px;
}
/* .top_nav_img:after {
  content: '.';
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
  font-size: 0;
}
.top_nav_img {
  *zoom: 1;
} */

.config_jie_mian {
  display: inline-block;
}
.config_jie_mian > div {
  display: inline-block;
  font-size: 16px;
  margin-left: 20px;
  padding: 0px 15px;
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.3);
}

/* .config_nickName_input_wraper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
} */
</style>
